import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 14.5L10.2304 10.2304M11.6961 6.59804C11.6961 9.41361 9.41361 11.6961 6.59804 11.6961C3.78247 11.6961 1.5 9.41361 1.5 6.59804C1.5 3.78247 3.78247 1.5 6.59804 1.5C9.41361 1.5 11.6961 3.78247 11.6961 6.59804Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgSearch;
